<template>
  <div class="not-found-view website">
    <website-header />
    <div class="_body">
      <div class="container">
        <h1>
          Browser unsupported
        </h1>
        <div :style="{ textAlign: 'center', fontSize: $fontSizes[7] }">
          Unfortunately, we don't support your browser yet. Currently, we only
          support Google Chrome.
        </div>
      </div>
      <c-divider />
      <website-footer />
    </div>
  </div>
</template>

<script>
import CDivider from 'shared/components/CDivider.vue';
import WebsiteFooter from '@/components/WebsiteFooter.vue';
import WebsiteHeader from '@/components/WebsiteHeader.vue';

export default {
  name: 'NotFoundView',
  components: { WebsiteHeader, WebsiteFooter, CDivider },
};
</script>

<style
  scoped
  type="text/scss"
  lang="scss"
>
@import "shared/assets/scss/box-shadow";

.not-found-view {
  .container {
    min-height: calc(100vh - 60rem);
    max-width: 50rem;
  }
}
</style>
